<template>
  <div style="font-family: montserrat_Regular;">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout pb-12 xs12 sm12 md12 wrap>
      <v-flex>
        <v-layout wrap pt-10 justify-center>
          <v-flex xs12 md8 text-center>
            <span class="login_head">Log in</span>
          </v-flex>
        </v-layout>
        <v-form @submit.prevent="submit">
          <v-layout wrap justify-center pt-3>
            <v-flex xs12 sm6 md3 pt-5 px-4>
              <v-text-field
                ref="userName"
                :rules="[rules.required]"
                v-model="userName"
                :error-messages="msg_username"
                label="Username"
                color="#26af82"
                required
              ></v-text-field>
              <v-text-field
                ref="password"
                v-model="password"
                label="Password"
                :rules="[rules.required]"
                :error-messages="msg_password"
                type="password"
                color="#26af82"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout v-if="msg" wrap justify-center pt-3>
            <v-flex xs12 md3 pa-2 text-center>
              <span style="font-size:14px;color:red;">{{msg}}</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 md12 pt-2 text-center>
              <v-btn
                width="220px"
                class="text-capitalize"
                dark
                small
                :ripple="false"
                color="#26af82"
                type="submit"
              >Log In</v-btn>
            </v-flex>
          </v-layout>
        </v-form>

        <v-layout wrap justify-center>
          <v-flex xs12 md3 pt-5 text-center>
            <router-link to="/ForgotPassword">
              <span style="font-size:14px;color:#26af82">Forgot Password?</span>
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 sm6 md3 pt-5 text-center>
            <span>
              <hr style="height:1px; border:none;background-color:#e6e6e6;" />
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 md3 pt-5 text-center>
            <span style="font-weight:500">Don't have an account?</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 md3 pt-2 pb-6 text-center>
            <router-link to="/Signup">
              <v-btn
                small
                dark
                :ripple="false"
                class="text-capitalize"
                outlined
                color="#26af82"
                width="220"
              >Sign up</v-btn>
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      userName: null,
      password: null,
      loginexist: false,
      rememberMe: false,
      loginBtn: true,
      appLoading: false,
      msg: null,
      ServerError: false,
      msg_username: null,
      msg_password: null,
      rules: {
        required: value => !!value || "Required"
      },
      otp: null
    };
  },
  computed: {
    form() {
      return {
        userName: this.userName,
        password: this.password
      };
    }
  },
  watch: {
    userName: function() {
      if (this.userName && this.password) this.loginBtn = false;
      else this.loginBtn = true;
    },
    password: function() {
      if (this.userName && this.password) this.loginBtn = false;
      else this.loginBtn = true;
    },
    otp: function() {
      if (this.otp.length == 5) {
        document.getElementById("otpinpt").classList.add("otphide");
      } else {
        document.getElementById("otpinpt").classList.remove("otphide");
      }
    }
  },
  methods: {
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
      });

      this.appLogin();
    },
    appLogin() {
      if (this.formHasErrors) {
        // this.msg = "Please Validate Input";
      } else {
        this.appLoading = true;
        this.OTPVerified = true;
        var logindata = {};
        logindata["username"] = this.userName;
        logindata["password"] = this.password;
        logindata["override"] = this.loginexist;
        axios({
          method: "POST",
          url: "/user/login",
          data: logindata
        })
          .then(response => {
            this.appLoading = false;
            // this.msg = response.data.msg;
            if (response.data.status) {
              this.$emit("stepper", {
                winStep: 1,
                userId: response.data.id,
                authcode: response.data.code
              });
            } else {
              if (
                response.data.msg ===
                "You are already logged in. Re-submit to destroy existing session and login"
              ) {
                this.loginexist = true;
                this.msg = response.data.msg;
                this.msg_username = null;
                this.msg_password = null;
              } else if (response.data.msg == "user not found.") {
                this.msg_username = response.data.msg;
                this.msg = null;
                this.msg_password = null;
              } else {
                this.msg_password = response.data.msg;
                this.msg = null;
                this.msg_username = null;
              }
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
      // setTimeout(() => {
      //   this.$emit("stepper", { winStep: 1 });
      // }, 1000);
    }
  }
};
</script>
<style>
.login_head {
  font-family: montserrat_Bold;
  font-size: 20px;
  font-weight: 500;
}
</style>